"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.normalizeName = exports.DimensionalElement = void 0;
/**
 * @internal
 */
class DimensionalElement {
    constructor(name, type, desc, dataSource, composeCode) {
        this._name = name;
        this.type = type;
        this.description = desc || '';
        if (dataSource) {
            this._dataSource = dataSource;
        }
        this.composeCode = composeCode;
    }
    /**
     * Defines the element's name
     */
    get name() {
        return this._name;
    }
    set name(value) {
        this._name = value;
    }
    /**
     * Defines the element's data source
     */
    get dataSource() {
        return this._dataSource;
    }
    /**
     * Gets a serializable representation of the element
     */
    serializable() {
        return {
            name: this.name,
            type: this.type,
            desc: this.description,
            dataSource: this.dataSource,
            __serializable: 'DimensionalElement',
        };
    }
    toJSON() {
        return this.serializable();
    }
    /**
     * Gets a string representation of the element
     */
    toString() {
        return this.jaql();
    }
}
exports.DimensionalElement = DimensionalElement;
/**
 * @param name
 * @internal
 */
function normalizeName(name) {
    // Remove all invalid characters
    let normalizedName = name.replace(/[^a-zA-Z0-9_.]/g, '').replace(/\./g, '_');
    // Prefix with '_' if it starts with a number
    const firstChar = normalizedName.charAt(0);
    if (firstChar.match(/[0-9]/)) {
        normalizedName = '_' + normalizedName;
    }
    return normalizedName;
}
exports.normalizeName = normalizeName;
